//Booking helper state constants
export const START_BOOKING = 'start_booking'
export const SET_PATIENTS_FOR_USER = 'set_patients_for_user'
export const UPDATE_BOOKING_HELPER_FILTERS = 'update_booking_helper_filters'
export const SET_DROPDOWN_PATIENTS = 'set_dropdown_patients'
export const UPDATE_BOOKING_HELPER_DETAILS = 'update_booking_helper_details' //To update any booking helper related info eg counselling type
export const COMPLETE_BOOKING = 'COMPLETE_BOOKING'
export const SET_B2B_DETAILS = 'SET_B2B_DETAILS'
export const SET_RP_DETAILS = 'SET_RP_DETAILS'
//Booking states constants
export const SET_SELECTED_PATIENTS = 'set_selected_patients'
export const UPDATE_BOOKING_DETAILS = 'update_booking_details' //To update any booking related info eg counselling type

//Booking Helper no persist
export const ADD_NEW_PATIENTS = 'add_new_patients'
export const RESET_PATIENT_FORM = 'reset_patient_form'

//Salesforce
export const SET_SALESFORCE_DETAILS = 'SET_SALESFORCE_DETAILS'
export const CLEAR_SALESFORCE_DETAILS = 'CLEAR_SALESFORCE_DETAILS'

//Common
export const CLEAN_BOOKING_INFO = 'clean_booking_info'

export const initialBookingState: BookingState = {
  providerId: '',
  selectedPatients: [],
  counselingTypeId: '',
  counselingType: '',
  appointmentMode: '',
}

/* Since we are reading below properties from selectedSlot.slot object in user/(email, patient-info, payment) and support/(email, patient-info, payment) pages,
 * on cleaning the booking info after Login, Logout or Successfull booking, a "Cannot read properties... of null is thrown in UI. So setting
 * the value of these properties to a meaningful value. */

const noSelectedSlot = {
  id: '',
  start: '',
  end: '',
  practiceId: '',
}

export const initialBookingHelperState: BookingHelperState = {
  selectedSlot: {
    slot: noSelectedSlot,
    provider: null,
  },
  providerDetails: null,
  allPatients: [],
  dropdownPatients: [],
  filters: {
    slotAvailabilityTypes: [],
  },
  groupedFilters: null,
  dbUser: null,
  userEmail: '',
  isBookingComplete: false,
  responsibleParty: null,
}

export const initialBookingHelperNoPersist: BookingHelperNoPersist = {
  newPatients: [],
  patientFormReset: false,
}

export const enum AppointmentBookingFlag {
  SUPPORT_BOOKING_FUNNEL = 'support_booking_funnel',
  PATIENT_BOOKING_FUNNEL = 'patient_booking_funnel',
  PATIENT_BOOKING_V2_FUNNEL = 'patient_booking_v2_funnel',
  CLINICIAN_CALENDAR_CREATION = 'clinician_calendar_creation',
}
